import { Icon, IconProps } from "@chakra-ui/react";

export default function CaminoCrownIcon({
  color = "white",
  ...rest
}: IconProps) {
  return (
    <Icon
      viewBox="0 0 8 8"
      color={color}
      {...rest}
    >
      <path
        d="M3.88884 1.8634L2.71763 3.80785L0.972168 2.67359L1.45828 5.91433H6.31939L6.8055 2.67359L5.06004 3.80785L3.88884 1.8634Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
}
